// src/hooks/usePinGuard.js
import { useEffect, useState } from 'react';
import { isLocalhost } from './wkCommon';

export function usePinGuard(timeoutMinutes = 60) {
  const [needsPin, setNeedsPin] = useState(false);

  // update lastActivity on interactions
  useEffect(() => {
    // If localhost/dev => skip PIN confirmation entirely
    if (isLocalhost) {
      setNeedsPin(false);
      // return empty cleanup since we do not attach any listeners/intervals
      return () => {};
    }

    // update lastActivity on interactions
    const handler = () => {
      sessionStorage.setItem('lastActivityAt', Date.now().toString());
    };
    ['click', 'keydown', 'mousemove', 'touchstart'].forEach(evt => window.addEventListener(evt, handler));
    // initialize lastActivity if absent
    if (!sessionStorage.getItem('lastActivityAt')) {
      sessionStorage.setItem('lastActivityAt', Date.now().toString());
    }
    const checkInterval = setInterval(() => {
      const lastAct = parseInt(sessionStorage.getItem('lastActivityAt') || '0', 10);
      const now = Date.now();
      const idleMs = now - lastAct;
      if (idleMs > timeoutMinutes * 60 * 1000) {
        // idle too long -> force reverify
        sessionStorage.removeItem('pinLastVerifiedAt');
      }
      const lastVerified = parseInt(sessionStorage.getItem('pinLastVerifiedAt') || '0', 10);
      // needs pin if no lastVerified or old
      if (!lastVerified || (now - lastVerified) > timeoutMinutes * 60 * 1000) {
        setNeedsPin(true);
      } else {
        setNeedsPin(false);
      }
    }, 2000);

    return () => {
      ['click', 'keydown', 'mousemove', 'touchstart'].forEach(evt => window.removeEventListener(evt, handler));
      clearInterval(checkInterval);
    };
  }, [timeoutMinutes]);

  return { needsPin, setNeedsPin };
}
